import styled from 'styled-components';

export const ScrollView = styled.div<{ $maxHeight?: string }>`
  max-height: ${({ $maxHeight }): string => $maxHeight ?? '300px'};
  overflow: auto;

  ::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: var(--white20);
  }

  ::-webkit-scrollbar {
    width: 4px;
    background-color: var(--white20);
    border-radius: 2px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background-color: var(--primary);
  }
`;
